// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	
	//Check Language for Menu on Desktop
    if (wixWindow.formFactor === "Desktop") {
        if (wixWindow.multilingual.currentLanguage ===  'he') {
            $w('#horizontalMenu2').hide();
            $w('#horizontalMenu1').show();
        } else {
            $w('#horizontalMenu1').hide();
            $w('#horizontalMenu2').show();
        }
    }

});